<template>
  <div class="container">
    <Container :active_path="path" :plate="'项目巡览'">
      <div class="base-warp">
        <div class="head">
          <el-form :model="search" ref="form" label-width="80px" :inline="true" size="normal">
            <el-form-item label="名称">
              <el-input v-model="search.title" size="mini" placeholder="请输入会员福利名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="mini" @click="confirm">搜索</el-button>
              <el-button type="success" size="mini" @click="reset">重置</el-button>

              <el-button type="primary" size="mini" @click="addp">添加会员福利</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div>
          <el-dialog v-bind="$attrs" v-on="$listeners" :visible.sync="dialogVisible" title="会员福利" width="60%">
            <el-row :gutter="24">
              <el-form ref="elForm" :model="formData" :rules="rules" size="small" label-width="100px"
                label-position="left">
                <el-row :gutter="15">
                  <el-col :span="12">
                    <el-form-item label="福利名称" prop="title">
                      <el-input v-model="formData.title" placeholder="请输入福利名称" show-word-limit clearable
                        prefix-icon='el-icon-s-opportunity' :style="{ width: '100%' }"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="15">
                  <el-col :span="12">
                    <el-form-item label="产品排序">
                      <el-input type="number" v-model="formData.listorder" placeholder="产品排序"></el-input>
                      <div>排序值 越小越靠前</div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="福利介绍" prop="info">
                      <el-input v-model="formData.info" placeholder="请精简福利介绍" show-word-limit clearable
                        prefix-icon='el-icon-s-opportunity' :style="{ width: '100%' }"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="15">
                  <el-col :span="12">
                    <el-form-item label="领取时间范围">
                      <el-date-picker v-model="formData.gettime" type="datetimerange" value-format="yyyy-MM-dd-hh-mm-ss"
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" />
                    </el-form-item>
                  </el-col>

                  <el-col :span="12">

                    <el-form-item label="使用时间范围">
                      <el-date-picker v-model="formData.usetime" type="datetimerange" value-format="yyyy-MM-dd-hh-mm-ss"
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" />
                    </el-form-item>
                  </el-col>

                </el-row>
                <el-row :gutter="24">
                  <el-col :span="24">
                    <el-form-item label="福利详情">
                      <tin-editor :value="formData.content" class="tin-editor" @input="getcontent"></tin-editor>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="15">

                  <el-col :span="12">
                    <el-form-item label="福利封面">
                      <el-upload class="upload-demo" drag action="/api/Upload/uploadfilevsnologo/"
                        :on-success="handleUploadSuccessbigimg" :before-upload="beforeUploadbigimg" multiple :limit="1">
                        <i class="el-icon-upload"></i>

                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过1M</div>

                      </el-upload>
                    </el-form-item>
                    <div v-if="imageUrlbigimg" style="text-align: center;" class="el-upload__text">图片如下</em></div>

                    <img v-if="imageUrlbigimg" :src="imageUrlbigimg" class="avatar" style="text-align: center;">
                  </el-col>
                  <el-col :span="12">

                    <el-form-item label="福利头像">
                      <el-upload class="upload-demo" drag action="/api/Upload/uploadfilevsnologo/"
                        :on-success="handleUploadSuccess" :before-upload="beforeUpload" multiple :limit="1">
                        <i class="el-icon-upload"></i>

                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过1M</div>

                      </el-upload>
                    </el-form-item>
                    <div v-if="imageUrl" style="text-align: center;" class="el-upload__text">图片如下</em></div>

                    <img v-if="imageUrl" :src="imageUrl" class="avatar" style="text-align: center;">
                  </el-col>
                </el-row>

              </el-form>
            </el-row>

            <div slot="footer">
              <el-button @click="close">取消</el-button>
              <el-button type="primary" @click="handleConfirm">确定</el-button>
            </div>
          </el-dialog>
        </div>
        <div class="table-box">
          <el-table :data="tabledata" border size="mini"
            :header-cell-style="{ background: '#f7f7f7', color: '#999', textAlign: 'center', fontWeight: 'normal' }">
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column prop="title" label="会员福利名称" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="info" label="会员福利介绍" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="number" label="领取数量" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="addtime" label="添加时间" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="listorder" label="数据排序" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="pics" label="会员福利头像" show-overflow-tooltip align="center">
              <template slot-scope="s">
                <el-image style="width: 100px; height: 50px; margin-bottom:-4px;" :src="s.row.img" />
              </template>
            </el-table-column>
            <el-table-column prop="index" label="操作" width="210">
              <template slot-scope="s">
                <el-button type="warning" v-if="s.row.putaway" size="mini" @click="putaway(s.row)">下架</el-button>
                <el-button type="success" v-if="!s.row.putaway" size="mini" @click="putaway(s.row)">上架</el-button>
                <el-button type="danger" size="mini" @click="del(s.row)">删除</el-button>
                <el-button type="primary" size="mini" @click="edit(s.row)" plain>编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination class="page-tion" @current-change="currentChange" layout="prev, pager, next" :page-size="pagesize"
          :total="total" background>
        </el-pagination>
      </div>
    </Container>
    <!-- <router-view></router-view> -->
  </div>
</template>

<script>
import Container from "../../../components/container";
import TinEditor from '../../../components/tin-editor.vue'  // 富文本

export default {
  components: {
    Container, TinEditor
  },
  data () {
    return {
      path: '/reallyWillBuy/member',
      search: {
        title: '',
      },
      dialogVisible: false,
      pageNo: 1,
      pagesize: 14,
      formData: {
        title: '',//会员福利名称
        img: '', //会员福利头像
        bigimg: '',//详情大图片
        info: '',//会员福利简介
        content: '',//会员福利详情
        listorder: '',//会员福利排序
        gettime:[],
        usetime:[],
        id: '',
      },
      rules: {
        title: [{
          required: true,
          message: '请输入该会员福利名称',
          trigger: 'blur'
        }],
        info: [{
          required: true,
          message: '请输入该会员福利介绍',
          trigger: 'blur'
        }]
      },
      tabledata: [],
      total: 0,
      imageUrl: '',
      imageUrlbigimg: ''

    }
  },
  mounted () {
    this.getTableData();
  },
  methods: {
    getcontent (content) {
      this.formData.content = content;
    },
    addp () {
      this.dialogVisible = true
      this.formData = {}
      this.imageUrl = ''
      this.imageUrlbigimg = ''

    },
    edit (row) {
      console.log(row);
      this.dialogVisible = true
      this.formData = row
      this.imageUrl = row.img
      this.imageUrlbigimg = row.bigimg
      this.formData.gettime = row.gettime
      this.formData.usetime = row.usetime
      this.$set(this.formData.gettime, 0, new Date(row.gettime[0]))// 回显的日期
      this.$set(this.formData.gettime, 1, new Date(row.gettime[1]))// 回显的日期
      this.$set(this.formData.usetime, 0, new Date(row.usetime[0]))// 回显的日期
      this.$set(this.formData.usetime, 1, new Date(row.usetime[1]))// 回显的日期

    },
    close () {

      this.dialogVisible = false
    },
    handleConfirm () {
          var params = {
            id: this.formData.id,
            title: this.formData.title,
            img: this.formData.img,
            bigimg: this.formData.bigimg,
            info: this.formData.info,
            listorder: this.formData.listorder,
            content: this.formData.content,
            gettime: this.formData.gettime,
            usetime: this.formData.usetime
          }
          if (!params.gettime) {
            return this.$message.error('请输入领取时间范围')
          }
          if (!params.usetime) {
            return this.$message.error('请输入用户可使用的时间范围')
          }
          this.$api.addmemberBenefits(params).then(res => {
            console.log(res, '=====');
            if (res === '添加成功' || res === '修改成功') {
              this.$message.success(res);
              this.dialogVisible = false
            }
            this.getTableData();
            this.formData = {}
            this.imageUrl = ''

          })
      
    },
    beforeUpload (file) {
      let isRightSize = file.size / 1024 / 1024 < 1
      if (!isRightSize) {
        this.$message.error('文件大小超过 1MB')
      }
      let isAccept = new RegExp('image/*').test(file.type)
      if (!isAccept) {
        this.$message.error('应该选择image/*类型的文件')
      }
      return isRightSize && isAccept
    },
    // 文件上传成功时的钩子
    handleUploadSuccess (item, response) {
      let { data, errCode, msg } = response;
      console.log(data, 'data');
      console.log(item, 'item');

      if (item.msg === '上传成功') {
        this.$message.success('上传成功');
        this.formData.img = item.data
        this.imageUrl = item.data

        this.$forceUpdate()
      } else {
        this.$message.error('上传失败');
      }
    },
    beforeUploadbigimg (file) {
      let isRightSize = file.size / 1024 / 1024 < 1
      if (!isRightSize) {
        this.$message.error('文件大小超过 1MB')
      }
      let isAccept = new RegExp('image/*').test(file.type)
      if (!isAccept) {
        this.$message.error('应该选择image/*类型的文件')
      }
      return isRightSize && isAccept
    },
    // 文件上传成功时的钩子
    handleUploadSuccessbigimg (item, response) {
      let { data, errCode, msg } = response;
      console.log(data, 'data');
      console.log(item, 'item');

      if (item.msg === '上传成功') {
        this.$message.success('上传成功');
        this.formData.bigimg = item.data
        this.imageUrlbigimg = item.data

        this.$forceUpdate()
      } else {
        this.$message.error('上传失败');
      }
    },
    confirm () {
      this.pageNo = 1;
      this.getTableData();
    },
    currentChange (page) {
      this.pageNo = page;
      this.getTableData();
    },
    //上下架
    putaway (row) {
      var params = {
        id: row.id,
        putaway: !row.putaway
      };
      this.$api.putuserWelfareStatus(params).then((data) => {
        this.$message.success(data);
        this.getTableData();
      });
    },
    del (row) {
      this.$confirm("是否确定删除" + row.title).then(
        (confirm) => {
          var params = {
            id: row.id
          };
          this.$api.delmemberBenefits(params).then((data) => {
            this.$message.success(data);
            this.getTableData();
          });
        },
        (cancel) => { }
      );
    },
    getTableData () {
      var params = {
        title: this.search.title
      }
      this.$api.listmemberBenefits(params).then(data => {
        console.log(data, '---');
        this.tabledata = data.list;
        this.total = data.total;
      })
    },
    reset () {
      this.search.title = ''
      this.getTableData()
    },

  },
}
</script>

<style lang="scss" scoped>
.el-rate {
  display: inline-block;
  vertical-align: text-top;
}

.el-upload__tip {
  line-height: 1.2;
}

.right-edit-box {
  position: absolute;
  right: 0;
  top: 0;
}

.el-carousel__item {
  background: #fff;
  border: 1px dashed #999;

  .img {
    width: 270px;
    height: 202px;
    vertical-align: middle;
    position: relative;
  }

  .name {
    position: absolute;
    color: #fff;
    padding: 0 6px;
    background: rgba(0, 0, 0, 0.4);
    bottom: 4px;
    left: 4px;
  }
}

.left-row {
  border: 1px dashed #d9d9d9
}

.avatar {
  // margin-left: 40px;
  width: 250px;
  height: 180px;
  display: block;
  margin: 0 auto;
}

.tin-editor {
  width: 100%;
}
</style>